module.exports = __webpack_public_path__ + "img/medal-start.c387f5be.png";